import { graphql } from "~/gql";

export const FIND_CLIENTS_BY_IDS = graphql(/* GraphQL */ `
  query FindClientsByIds($ids: [Int!]!) {
    getClientsByIds(ids: $ids) {
      id
      name
    }
  }
`);
